import Vue from "vue";
import moment from "moment";
import "moment/locale/it"; // without this line it didn't work
moment.locale("it");

Vue.filter("formatDate", function(value, format = "DD/MM/YYYY") {
  if (value) {
    return moment(String(value)).format(format);
  }
});

Vue.filter("currency", function(item) {
  if (item !== undefined) {
    item = item / 100;
    let value = item.toString();
    if (value.indexOf("€") !== -1) {
      value = value.replace("€", "");
    }
    if (value.indexOf(".") !== -1) {
      value = value.replace(".", ",");
    } else {
      value = value + ",00";
    }

    const valueArray = value.split(",");
    let int = valueArray[0];
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    let decimal = valueArray[1].substring(0, 2);

    if (decimal.length < 2) {
      decimal = decimal + "0";
    }

    value = int + "," + decimal + "€";

    const checkNaN = isNaN(parseFloat(int));

    if (checkNaN || value === "0,00€") {
      value = "-";
    }

    return value;
  }
});

Vue.filter("currencyWithZeroValue", function(item) {
  if (item !== undefined) {
    item = item / 100;
    let value = item.toString();
    if (value.indexOf("€") !== -1) {
      value = value.replace("€", "");
    }
    if (value.indexOf(".") !== -1) {
      value = value.replace(".", ",");
    } else {
      value = value + ",00";
    }

    const valueArray = value.split(",");
    let int = valueArray[0];
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    let decimal = valueArray[1].substring(0, 2);

    if (decimal.length < 2) {
      decimal = decimal + "0";
    }

    value = int + "," + decimal + "€";

    return value;
  }
});
